import { render } from "./SoftSkills.vue?vue&type=template&id=f253502e"
import script from "./SoftSkills.vue?vue&type=script&lang=js"
export * from "./SoftSkills.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Programación\\Desktop\\openbootcamp\\Vuejs\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__